import { useContext, useEffect, useState } from "react";
import {
  HEADER_NAV_BUTTON_CLOSE,
  HEADER_NAV_BUTTON_MENU,
  HEADER_NAV_BUTTON_PREV,
} from "../../../components/header/Header";
import { TransferContext } from "../../../context/TransferContext";
import {
  STEP_CONFIRM_TRANSFER_DETAILS,
  STEP_CONSENT,
  STEP_DESTINATION_ACCOUNT,
  STEP_DESTINATION_CONNECT_ES,
  STEP_DESTINATION_CONNECT_ES_DETAILS,
  STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT,
  STEP_DESTINATION_CONNECT_IRA,
  STEP_DESTINATION_CONNECT_IRA_TYPE,
  STEP_DESTINATION_EXPLORE_IRA,
  STEP_DESTINATION_EXPLORE_IRA_1,
  STEP_DESTINATION_EXPLORE_IRA_2,
  STEP_DESTINATION_EXPLORE_IRA_3,
  STEP_DESTINATION_EXPLORE_IRA_LOADING,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI,
  STEP_DESTINATION_EXPLORE_IRA_OPTIONS,
  STEP_DESTINATION_EXPLORE_IRA_RESULT,
  STEP_DESTINATION_HELP,
  STEP_DESTINATION_HELP_1,
  STEP_DESTINATION_HELP_2,
  STEP_DESTINATION_HELP_3,
  STEP_DESTINATION_HELP_4,
  STEP_DESTINATION_HELP_5,
  STEP_DESTINATION_HELP_6A,
  STEP_DESTINATION_HELP_6B,
  STEP_DESTINATION_HELP_6C,
  STEP_DESTINATION_HELP_RESULT,
  STEP_DESTINATION_IRA_FOUND,
  STEP_DESTINATION_OPTIONS,
  STEP_DESTINATION_OPTIONS_TYPE,
  STEP_INITIATE_TRANSFER,
  STEP_IRA_EXIT_SCREEN,
  STEP_MAILING_ADDRESS,
  STEP_MARTIAL_INFO,
  STEP_OLD_ACCOUNT_COMPLETED_HOME,
  STEP_OLD_ACCOUNT_CONFIRM,
  STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS,
  STEP_OLD_ACCOUNT_FLASH_LOADING,
  STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT,
  STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT,
  STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN,
  STEP_OLD_ACCOUNT_PROVIDER_SEARCH,
  STEP_OLD_ACCOUNT_SPONSOR_NAME,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED,
  STEP_OPEN_IRA,
  STEP_PERSONAL_INFO,
  STEP_POST_TRANSFER,
  STEP_SCHEDULE_PHONE_CALL,
  STEP_SCHEDULE_PHONE_CALL_CONFIRMATION,
  STEP_TRANSFER_INFO,
} from "../../../class/transferDetails";

import useOldAccountDetails from "../../old-account/useOldAccountDetails";

// Left button - iconName and function
// Right button - Only Hamburger menu

const useHeaderController = () => {
  const {
    currentScreen,
    isLoading,
    onClickMenubutton,
    clickClose,
    shouldShowHomeScreen,
    transferDetails,
    showError,
    goToPreviousScreen,
  } = useContext(TransferContext);
  const [navButton, setNavButton] = useState<typeof HEADER_NAV_BUTTON_MENU | undefined>(undefined);
  const [leftButton, setLeftButton] = useState<
    { icon: typeof HEADER_NAV_BUTTON_PREV | typeof HEADER_NAV_BUTTON_CLOSE; function: () => void } | undefined
  >(undefined);

  const { currentOldAccountDetails } = useOldAccountDetails();

  useEffect(() => {
    if (isLoading || showError) {
      setNavButton(undefined);
      setLeftButton(undefined);
    } else if (shouldShowHomeScreen) {
      setNavButton(HEADER_NAV_BUTTON_MENU);
      setLeftButton(undefined);
    } else {
      switch (currentScreen) {
        case STEP_CONSENT:
        case STEP_TRANSFER_INFO:
        case STEP_POST_TRANSFER:
        case STEP_SCHEDULE_PHONE_CALL:
        case STEP_SCHEDULE_PHONE_CALL_CONFIRMATION:
        case STEP_IRA_EXIT_SCREEN:
        case STEP_OPEN_IRA:
          setNavButton(undefined);
          setLeftButton({ icon: HEADER_NAV_BUTTON_CLOSE, function: clickClose });
          break;
        case STEP_OLD_ACCOUNT_SPONSOR_NAME:
          const completedSourceAccounts = transferDetails.sourceAccounts.filter(
            (s) => s.isCompleted && s.sourceAccountId !== currentOldAccountDetails.sourceAccountId,
          );
          if (completedSourceAccounts.length > 0) {
            setNavButton(HEADER_NAV_BUTTON_MENU);
            setLeftButton({ icon: HEADER_NAV_BUTTON_PREV, function: goToPreviousScreen });
          } else {
            setNavButton(undefined);
            setLeftButton({ icon: HEADER_NAV_BUTTON_CLOSE, function: clickClose });
          }
          break;
        case STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT:
        case STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS:
        case STEP_OLD_ACCOUNT_PROVIDER_SEARCH:
        case STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN:
        case STEP_OLD_ACCOUNT_UPLOAD_STATEMENT:
        case STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED:
        case STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT:
        case STEP_OLD_ACCOUNT_COMPLETED_HOME:
          setNavButton(HEADER_NAV_BUTTON_MENU);
          setLeftButton({ icon: HEADER_NAV_BUTTON_PREV, function: goToPreviousScreen });
          break;
        case STEP_OLD_ACCOUNT_CONFIRM:
          setNavButton(HEADER_NAV_BUTTON_MENU);
          setLeftButton(undefined);
          break;
        case STEP_DESTINATION_ACCOUNT:
        case STEP_DESTINATION_IRA_FOUND:
        case STEP_DESTINATION_OPTIONS:
        case STEP_DESTINATION_OPTIONS_TYPE:
        case STEP_DESTINATION_ACCOUNT:
        case STEP_DESTINATION_CONNECT_IRA:
        case STEP_DESTINATION_CONNECT_ES:
        case STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT:
        case STEP_DESTINATION_CONNECT_ES_DETAILS:
        case STEP_DESTINATION_HELP:
        case STEP_DESTINATION_HELP_1:
        case STEP_DESTINATION_HELP_2:
        case STEP_DESTINATION_HELP_3:
        case STEP_DESTINATION_HELP_4:
        case STEP_DESTINATION_HELP_5:
        case STEP_DESTINATION_HELP_6A:
        case STEP_DESTINATION_HELP_6B:
        case STEP_DESTINATION_HELP_6C:
        case STEP_DESTINATION_HELP_RESULT:
        case STEP_DESTINATION_EXPLORE_IRA:
        case STEP_DESTINATION_EXPLORE_IRA_1:
        case STEP_DESTINATION_EXPLORE_IRA_2:
        case STEP_DESTINATION_EXPLORE_IRA_3:
        case STEP_DESTINATION_EXPLORE_IRA_LOADING:
        case STEP_DESTINATION_EXPLORE_IRA_RESULT:
        case STEP_DESTINATION_EXPLORE_IRA_OPTIONS:
        case STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY:
        case STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT:
        case STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD:
        case STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI:
        case STEP_DESTINATION_CONNECT_IRA_TYPE:
        case STEP_CONFIRM_TRANSFER_DETAILS:
        case STEP_PERSONAL_INFO:
        case STEP_MARTIAL_INFO:
        case STEP_MAILING_ADDRESS:
        case STEP_INITIATE_TRANSFER:
          setLeftButton({ icon: HEADER_NAV_BUTTON_PREV, function: goToPreviousScreen });
          setNavButton(HEADER_NAV_BUTTON_MENU);
          break;
        case STEP_OLD_ACCOUNT_FLASH_LOADING:
          setNavButton(undefined);
          setLeftButton(undefined);
          break;
        default:
          setNavButton(HEADER_NAV_BUTTON_MENU);
      }
    }
  }, [currentScreen, isLoading, shouldShowHomeScreen, showError]);

  return {
    navButton,
    clickClose,
    onClickMenubutton,
    shouldShowHomeScreen,
    leftButton,
  };
};

export default useHeaderController;
